import React from 'react';

const NoBookingsAvailable = ({ allOccasions, selectedArea, onChangeToEnquiry, phone, restaurantName, selectedDay, selectedMonth, selectedYear, venueEmail }) => {  

    const convertToEnquiry = () => {
        var enquiryOption = allOccasions.filter(o => o.areaLinkGroup.areaLinks[0] && o.areaLinkGroup.areaLinks[0].id == selectedArea.areaLinkGroup.areaLinks[0].id && o.name.indexOf('Enquiry') != -1);
        onChangeToEnquiry(enquiryOption.id)
    }

    const makeEnquiryValid = () => {
        var now = new Date();
        if (now.getDate() == selectedDay && now.getMonth() == selectedMonth && now.getFullYear() == selectedYear) {
            return false;
        }
        var enquiryOption = allOccasions.filter(o => o.areaLinkGroup.areaLinks[0] && o.areaLinkGroup.areaLinks[0].id == selectedArea.areaLinkGroup.areaLinks[0].id && o.name.indexOf('Enquiry') != -1);
        if (enquiryOption.length == 0) {
            return false;
        }
        return true;
    }

    const formatPhoneNumber = (phone) => {
        phone = phone.toString().replace("+", "").replace("44", "0")
        var phoneSplit = [phone.substring(0, 3), phone.substring(3, 7), phone.substring(7, 11)];
        var formattedNumber = phoneSplit.join(' ');
        return formattedNumber;
    }


    return (
        <>
            <style>
                {`

                .inactive button{
                    background-color: white;
                    color: black;
                    width: 50px;
                    padding: 5px;
                    margin: 5px;
                }

                
                .active button{
                    background-color: green;
                    color: white;
                    width: 50px;
                    padding: 5px;
                    margin: 5px;
                }
                `}
            </style>

            <div className='p-4 w-full bg-tomato text-off-white mt-5'>
                <div className='flex gap-2 justify-center'>
                    <div className="box-icon items-center flex">
                        <img src="/icons/common/offwhite/alert-circle.svg" alt="alert" />
                    </div>
                    <div className='mb-0 text-center'>Sorry, your preferred time isn't available.</div>
                </div>
            </div>
            { /* <div className='flex justify-center gap-2 text-basil text-lg mt-12'>
                <span>Call Jamie's {restaurantName} on </span>

                <a href={'tel:' + phone.toString().replace("44", "0")} className='flex gap-2 items-center'>
                    <div className='box-icon w-5 h-5'>
                        <img alt="phone icon" className="icon" src="/icons/restaurants/phone-call.svg" />
                    </div>
                    <div>
                        {formatPhoneNumber(phone)}
                    </div>
                </a>
            </div>*/}
            <div className='flex justify-center gap-2 text-basil text-lg mt-12'>
                <span>Contact Jamie's {restaurantName} on </span>

                <a href={'mailto:' + venueEmail} className='flex gap-2 items-center'>
                    <div className='box-icon w-5 h-5'>
                        <img alt="email icon" className="icon" src="/icons/careers/mail.svg" />
                    </div>
                    <div>
                        {venueEmail}
                    </div>
                </a>
            </div>

            {makeEnquiryValid() &&
                <div className="mt-5">
                    <span>If you'd rather be contacted by a member of our team, please submit an enquiry using the button below.</span>
                    <div className="mt-6 flex justify-center">
                        <button className="button" onClick={convertToEnquiry}>Make an Enquiry</button>
                    </div>
                </div>
            }
            
        </>);

}

export default NoBookingsAvailable;